export const ClaimsQualificationsTypes = {
    ProfessionalIllness: 'Enfermedad Profesional',
    Work: 'Trabajo',
    Journey: 'Trayecto',
    Administrative: 'Administrativa',
};

export const ClaimsTypeQualificationsTypes = {
    HealthQualification: 'Calificacion Medica',
    AdministrativeQualification: 'Calificacion Administrativa'
};

export const ClaimsTypes = {
    NoLaw: 'No Ley',
    Journey: 'Trayecto',
};

export const ClaimsQualifications = {
    DoesNotAcceptClaims: 'No Acoge Siniestro',
};

export const ClaimsJustifications = {
    OtherCauses: 'Otras causales de exclusión del seguro',
    YourStoryAlone: 'Su sólo relato no es suficiente, tampoco aporta medios probatorios',
    BackgroundInformation:
        'Antecedentes son insuficientes para acreditar el accidente como del trayecto',
    Inconsistency: 'Inconsistencia en el trayecto realizado',
    IndirectPath: 'Trayecto indirecto, desviado o interrumpido',
};

export const ClaimsJustificationsArray = [
    ClaimsJustifications.OtherCauses,
    ClaimsJustifications.YourStoryAlone,
    ClaimsJustifications.BackgroundInformation,
    ClaimsJustifications.Inconsistency,
    ClaimsJustifications.IndirectPath,
];

export const CanAppeal = {
    Yes: '1',
    No: '0',
};
